var _defs, _g, _image, _rect, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVulnCritical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-4 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #ce3727;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-4 {\n        clip-rule: evenodd;\n      }\n\n      .cls-9 {\n        isolation: isolate;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "42 6 83.1 78 1 78 42 6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.8,
    y: 33.5,
    width: 34.4,
    height: 31.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.5,61.9c-.3.5-.6.8-1.1,1.1-.5.3-1,.4-1.5.4h-25.9c-1.1,0-2-.6-2.6-1.5-.5-.9-.5-2.1,0-3l12.9-22.7c.3-.6.9-1.1,1.6-1.3.7-.2,1.4-.2,2,0,.7.2,1.2.7,1.6,1.3l12.9,22.7c.3.5.4,1,.4,1.5s-.1,1.1-.4,1.5h0ZM58.5,58.3l-12.9-22.7c-.5-.8-1.2-1.5-2.1-1.8-.9-.3-1.9-.3-2.8,0-.9.3-1.7,1-2.1,1.8l-12.9,22.7c-.7,1.3-.7,2.9,0,4.1.7,1.3,2.1,2.1,3.5,2.1h25.9c1.5,0,2.8-.8,3.5-2.1.7-1.3.7-2.9,0-4.1h0ZM42,58.9h0c-.4,0-.8-.4-.8-.8s.4-.8.8-.8h0c.4,0,.8.4.8.8s-.4.8-.8.8ZM42,56.1h0c-.7,0-1.3.4-1.7,1-.3.6-.3,1.3,0,1.9.3.6,1,1,1.7,1h0c.7,0,1.3-.4,1.7-1,.3-.6.3-1.3,0-1.9-.3-.6-1-1-1.7-1h0ZM42.9,52.7c0,.2,0,.4-.2.6-.2.2-.4.3-.6.3s-.4,0-.6-.3c-.2-.2-.2-.4-.2-.6v-9.5c0-.2,0-.4.2-.6.2-.2.4-.3.6-.3s.4,0,.6.3c.2.2.2.4.2.6v9.5ZM42,41.3c-.5,0-1,.2-1.4.6-.4.4-.6.9-.6,1.4v9.5c0,.5.2,1,.6,1.4.4.4.8.6,1.4.6.5,0,1-.2,1.4-.6.4-.4.6-.9.6-1.4v-9.5c0-.5-.2-1-.6-1.4-.4-.4-.8-.6-1.4-.6h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.3,
    y: 32,
    width: 37,
    height: 34
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 5,
    width: 84,
    height: 74
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 37,
    height: 34,
    transform: "translate(23.3 32)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAjCAYAAAD48HgdAAAACXBIWXMAAAsSAAALEgHS3X78AAAECklEQVRYhc3Y2YvVdRjH8dd3xnHMpdS0zKXFiqCyxYJooWghwlKzzaAuKqjbuim67SL6AyKiS7sINFuMFqUC66KsEIoyK1rUaLFSc88Z9eni+R4dl+Occ3K0B4bz48z5fc/n2d7P8zv8T60cjUMioqCn/u1FXyllz3EVFhFdGIfLMR1bsBI/lVJ2HRdhVdRkPIBrsANd6Mdz+BQ7SylxzITV9J2KJ2TEXsAajMBc3FDFLS+l9HX6PZ0IGxkR90fEkoi4JCJ6GoIj4pSIeDwiXoyIqdWJtqyrQ1FdOA3z8Ca+L6X0Q03bX3gNo3ELRh4TYfUL52InlmL7wH+WUvbiV7yOOZhanRk6YRHRjbNxM17GH02KeyfexwbcgROHTFitlbG4B9/iY/TVuhoeESdFxKiI6BqQ0oW4HudFxLAhESYBeqlk1kJsqgKG42o8hvswsaauTzLti+rMuFYboWVh9cCTMR8fYnUppb++P6GK6sVNMs0jquhNWIQZ1aHhR1WY5NN1shtfxeb6fjdOxxhZc59UEb1QStmN7/BedWpCK1FrSdgAPNwp8bC2dh4J6caM3Cbp3+tAeG+VHTpWRvSEoyJM4uE27MY7DsLDYFad+AVLcDumDIaPQYVVPJwlQbkI6zuZfTKS78ohP0+mvnNhMvx34UeJh442hurMn9K5G3HukfBxRGF1/s3AFRIPGzqMVsP68BlWyUZoio+mwgbg4V58hFWNedipVac2yqhdjJmycVoXJvFwLabhFfvx8J+s4uMbLJdRm3i4qB1WWP3gJImHt7GmjVW5YLB0b5EsnCD3tkPw0Sxio3FrvX5L8qmZhWyIbtkoY+QA39vshoqPn/GG7NDJB+PjEGEVD2diFhYbBA81Netkxz0sV+yVBu/eHVhWX+caBB8iYnxEPBURz0fEpFbGR0T0RMRFEfFIRMyOiLEt3tcbEXMiYmlEzKxBAcMO+mAPLsBVeFrreNgt9/0tMlLbWryvDysk1+7G2ojYWErZn9eD8LACX7aBh1H14GfwJKYP9L6ZDdg+FuIyuVL1cGCN9eJKOX4W4+9WFNWinYQH8VW9nq3FPb86v1quUvMxPiLKQGFj5H6+TD6stvMk3ainfuzR/mPhZvnwMkWCt6eLfWkcJ3f55drYHmrr/46XZMS3SsTsaPOM3/C5HIEjGsXfLeurX+a8KYOa2DYskCWwG1s6+O2iXzo4Fd0NYXvk41bIGluvjS2iFvF2be5pDasZG4Nz5IDvH9Y4OCI2y258CNsiYp30fqityEkzSwZlAf7ZV6S1u6bhUVyItTpLa7vWizPq67P4oJSy84DuqeLGy5CeX6+Pym9oR7A+/ICvZTntKqUcfmzUzbJXcm6ohUUV1zdwWvwLCIe1bcUFtKkAAAAASUVORK5CYII="
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.3,
    y: 32,
    width: 37,
    height: 34
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 23.8,
    y: 32.5,
    width: 36.4,
    height: 33.1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVulnCritical);
export default __webpack_public_path__ + "static/media/vuln-critical.594b0465015e78107cce8bdc83a1bb7e.svg";
export { ForwardRef as ReactComponent };